import auth from "./auth";
import coreServiceApi from "./coreServiceApi";

const exportDefult = {
  Auth: auth,
  CoreServices: coreServiceApi,
};
export default exportDefult;
